import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ActivityCategoriesState } from '@wilson/activity-categories/data';
import { FeatureFlagPurePipe } from '@wilson/feature-flags';
import { ActivityCategoriesIdsMap, ActivityCategory } from '@wilson/interfaces';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DefaultActivityCategoryService {
  private readonly featureFlagPurePipe = inject(FeatureFlagPurePipe);
  private readonly store = inject(Store);

  private readonly WilsonDefaultActivityCategoryId =
    'WilsonDefaultActivityCategoryId';

  public async getDefaultActivityCategoryId(
    fallbackActivityCategoryId?: string,
  ): Promise<string> {
    const defaultActivityCategoryId =
      fallbackActivityCategoryId ?? ActivityCategoriesIdsMap.TrainDrive;

    const isFeatureFlagEnabled = await firstValueFrom(
      this.featureFlagPurePipe.transform('portal-default-activity-categories'),
    );
    if (isFeatureFlagEnabled) {
      const userSelectedCategory = localStorage.getItem(
        this.WilsonDefaultActivityCategoryId,
      );
      return userSelectedCategory || defaultActivityCategoryId;
    } else {
      return defaultActivityCategoryId;
    }
  }

  public async getDefaultActivityCategory(
    fallbackActivityCategoryId?: string,
  ): Promise<ActivityCategory | undefined> {
    const defaultActivityCategoryId = await this.getDefaultActivityCategoryId(
      fallbackActivityCategoryId,
    );
    const category = this.store.selectSnapshot(
      ActivityCategoriesState.categoryById(defaultActivityCategoryId),
    );
    return category?.isEnabled ? category : undefined;
  }

  public setDefaultActivityCategoryId(id: string): void {
    try {
      localStorage.setItem(this.WilsonDefaultActivityCategoryId, id);
    } catch (error) {
      console.error('Failed to set default activity category:', error);
    }
  }
}
